import { render, staticRenderFns } from "./Ekwitansi.vue?vue&type=template&id=869a984e&"
import script from "./Ekwitansi.vue?vue&type=script&lang=js&"
export * from "./Ekwitansi.vue?vue&type=script&lang=js&"
import style0 from "./Ekwitansi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports